import Vue from 'vue';
import Router from 'vue-router';
import {BasicLayout} from '@/layouts';

Vue.use(Router);

// 基础路由
const basicRoutes = [
    {
        path: '*',
        redirect: '/404',
        hidden: true
    },
    {
        path: '/404',
        component: () => import('@/views/exception/404')
    },
]

const serviceRoutes = [
    {
        path: '/',
        component: BasicLayout,
        redirect: '',
        hidden: true,
        children: [
            {
                path: '',
                name: 'home',
                component: () => import('@/views/Home'),
                meta: {
                    title: '首页',
                    auth: false
                }
            },
            {
                path: '/signin',
                name: 'signin',
                component: () => import('@/views/user/Signin'),
                meta: {
                    title: '用户登录',
                    auth: false
                }
            },
            {
                path: '/signup',
                name: 'signup',
                component: () => import('@/views/user/Signup'),
                meta: {
                    title: '用户注册',
                    auth: false
                }
            },
            {
                path: '/reset',
                name: 'reset',
                component: () => import('@/views/user/Reset'),
                meta: {
                    title: '找回密码',
                    auth: false
                }
            },
            {
                path: '/info',
                name: 'info',
                component: () => import('@/views/info/Info'),
                meta: {
                    title: '校园资讯',
                    auth: false
                }
            },
            {
                path: '/infoDetail',
                name: 'infoDetail',
                component: () => import('@/views/info/InfoDetail'),
                meta: {
                    title: '校园资讯详情',
                    auth: false
                }
            },
            {
                path: '/overview',
                name: 'overview',
                component: () => import('@/views/overview/Overview'),
                meta: {
                    title: '学校概况',
                    auth: false
                }
            },
            {
                path: '/education',
                name: 'education',
                component: () => import('@/views/education/Education'),
                meta: {
                    title: '教育教学',
                    auth: false
                }
            },
            {
                path: '/classroom',
                name: 'classroom',
                component: () => import('@/views/classroom/Classroom'),
                meta: {
                    title: '在线课堂',
                    auth: false
                }
            },
            {
                path: '/campus',
                name: 'campus',
                component: () => import('@/views/campus/Campus'),
                meta: {
                    title: '校园文化',
                    auth: false
                }
            },
            {
                path: '/recruit',
                name: 'recruit',
                component: () => import('@/views/recruit/Recruit'),
                meta: {
                    title: '招生就业',
                    auth: false
                },

            },
            {
                path: '/product/info',
                name: 'productInfo',
                component: () => import('@/views/products/detail'),
                meta: {
                    title: '产品详情',
                    auth: false
                },

            },
            {
                path: '/product/list',
                name: 'productList',
                component: () => import('@/views/products/list'),
                meta: {
                    title: '产品列表',
                    auth: false
                },

            },
            {
                path: '/demand/info',
                name: 'demandInfo',
                component: () => import('@/views/demands/detail'),
                meta: {
                    title: '需求详情',
                    auth: false
                },

            },
            {
                path: '/demand/list',
                name: 'demandList',
                component: () => import('@/views/demands/list'),
                meta: {
                    title: '需求列表',
                    auth: false
                },
            },
            {
                path: '/institute/list',
                name: 'instituteList',
                component: () => import('@/views/institution/list'),
                meta: {
                    title: '金融机构列表',
                    auth: false
                },
            },
            {
                path: '/institute/info',
                name: 'instituteInfo',
                component: () => import('@/views/institution/detail'),
                meta: {
                    title: '金融机构详情',
                    auth: false
                },
            },
            {
                path: '/activity/list',
                name: 'activityList',
                component: () => import('@/views/activity/list'),
                meta: {
                    title: '活动列表',
                    auth: false
                },

            },
            {
                path: '/activity/info',
                name: 'activityInfo',
                component: () => import('@/views/activity/detail'),
                meta: {
                    title: '活动详情',
                    auth: false
                },

            },
            {
                path: '/talent/list',
                name: 'talentList',
                component: () => import('@/views/talent/talentList'),
                meta: {
                    title: '人才列表',
                    auth: false
                },

            },
            {
                path: '/tec',
                name: 'Tec',
                component: () => import('@/views/technology/tech'),
                meta: {
                    title: '产业科技创新服务',
                    auth: false
                },

            },
            {
                path: '/tec/news-list',
                name: 'TecNewsList',
                component: () => import('@/views/info/Info'),
                meta: {
                    title: '产业科技创新服务资讯',
                    auth: false
                },

            },
            {
                path: '/tec/news-detail',
                name: 'TecNewsDetail',
                component: () => import('@/views/info/InfoDetail'),
                meta: {
                    title: '产业科技创新服务资讯详情',
                    auth: false
                },

            },
            {
                path: '/ind-cg/detail',
                name: 'IndCgDetail',
                component: () => import('@/views/ind_cg/detail'),
                meta: {
                    title: '产业科技创新服务成果详情',
                    auth: false
                },

            },
            {
                path: '/ind-xq/detail',
                name: 'IndXqDetail',
                component: () => import('@/views/ind_xq/detail'),
                meta: {
                    title: '产业科技创新服务需求详情',
                    auth: false
                },

            },
            {
                path: '/ind-xq/list',
                name: 'IndXqList',
                component: () => import('@/views/ind_xq/list'),
                meta: {
                    title: '产业科技创新服务需求详列表',
                    auth: false
                },

            },
            {
                path: '/ind-cg/list',
                name: 'IndXqList',
                component: () => import('@/views/ind_cg/list'),
                meta: {
                    title: '产业科技创新服务需求详列表',
                    auth: false
                },

            },
        ]
    }
]


const routes = basicRoutes.concat(serviceRoutes);
const router = new Router({
    mode: 'history',
    routes,
    scrollBehavior: () => ({y: 0})   // 切换路由页面滚动到顶部
})


// 挂载前置路由导航守卫
router.beforeEach((to, from, next) => {
    // 对需要记录滚动条的路由进行处理
    if (from.meta.keepScroll) {
        from.meta.scrollTop = window.scrollY
    }
    //验证是否已获得授权
    if (localStorage.getItem('access_token')) {
        if (to.path === '/signin') {
            next('/')
        }
        next()
    }
    if (to.meta.auth) {
        next('/signin')
    }
    next()
})

// 挂载后置路由导航守卫
router.afterEach((to) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
})

// 导出路由
export default router
